import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';

import { AppComponent } from './app.component';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { HttpClientModule } from '@angular/common/http';
import { NgtUniversalModule } from '@ng-toolkit/universal';
import { HomeComponent } from './pages/home/home.component';
import { HeaderComponent } from './shared/header/header.component';
import { ModalContatoComponent } from './pages/home/modal-contato/modal-contato.component';
import { FooterComponent } from './shared/footer/footer.component';
import { AppRoutingModule } from './app-routing.module';
import { ModalContatoService } from './pages/home/modal-contato/modal-contato.service';

import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatDialogModule, MAT_DATE_LOCALE, MatRadioButton, MatRadioModule } from '@angular/material';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSliderModule} from '@angular/material/slider';

import { TextMaskModule } from 'angular2-text-mask';
import { ParceiroPrComponent } from './pages/parceiropr/parceiropr.component';
import { ModalCadastroPrComponent } from './pages/parceiropr/modal-contatoppr/modal-cadastroppr.component';
import { ModalCadastroParceiroPrService } from './pages/parceiropr/modal-contatoppr/modal-cadastroppr.service';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    ModalContatoComponent,
    FooterComponent,
    ParceiroPrComponent,
    ModalCadastroPrComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    CommonModule,
    TransferHttpCacheModule,
    HttpClientModule,
    NgtUniversalModule,
    AppRoutingModule,
    MatButtonModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule, 
    MatDialogModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    HttpClientModule, 
    TextMaskModule
  ],
  providers: [
    ModalContatoService,
    ModalCadastroParceiroPrService,
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'},
    { provide: LOCALE_ID, useValue: 'pt-PT' },
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
